/**
* 基础菜单 快递设置管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.name" placeholder="公司名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="有效状态" clearable>
          <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="addflashdialog" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editflashdialog" class="edit-button">修改</el-button>
        <!-- <el-button size="small" type="danger" @click="delflash">删除</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 85%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="公司名称" min-width="250" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="com_no" label="物流公司编码" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="seq" label="排序号" width="60" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180">
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row.id,scope.row.status)"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="contact_name" label="联系人" width="70" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="contact_tel" label="联系电话" width="110" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="contact_email" label="联系邮箱" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="contact_qq" label="联系QQ" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="addflashDialogVisible"
               width="30%"
               top="7vh"
               :before-close="handleClose"
               center>
      <el-form :model="flashForm" :rules="rules" ref="flashForm" label-width="155px" class="flashForm">
        <el-form-item label="公司名称" prop="name">
          <el-select v-model="flashForm.name" filterable placeholder="请选择公司名称" clearable
                     :filter-method="remoteMethod" @focus="focusLabelName()" @change="changeLabelName($event)" @clear="clear()">
            <el-option
              v-for="item in flashDeliveryListData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话" prop="contact_tel" class="relative">
          <el-input v-model="flashForm.contact_tel" clearable maxlength="11"  placeholder="请输入联系电话" onkeyup="this.value=this.value.replace(/\D/g,'')">
          </el-input>
        </el-form-item>
        <el-form-item label="有效状态" prop="status">
          <el-select v-model="flashForm.status" placeholder="请选择有效状态" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人" prop="contact_name" class="relative">
          <el-input v-model="flashForm.contact_name" clearable maxlength="20" placeholder="请输入联系人">
          </el-input>
        </el-form-item>
        <el-form-item label="联系QQ" prop="contact_qq" class="relative">
          <el-input v-model="flashForm.contact_qq" maxlength="10" clearable placeholder="请输入联系QQ" onkeyup="this.value=this.value.replace(/\D/g,'')">
          </el-input>
        </el-form-item>
        <el-form-item label="联系邮箱" prop="contact_email" class="relative">
          <el-input v-model="flashForm.contact_email" clearable maxlength="45" placeholder="请输入联系邮箱" onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')">
          </el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="seq">
          <el-input v-model="flashForm.seq" auto-complete="off" clearable maxlength="11" placeholder="请输入排序号">
          </el-input>
        </el-form-item>
        <el-form-item label="电子面单账号" prop="eorder_account" class="relative">
          <el-input v-model="flashForm.eorder_account" maxlength="50" clearable placeholder="请输入电子面单账号">
          </el-input>
        </el-form-item>
        <el-form-item label="电子面单密码" prop="eorder_pwd" class="relative">
          <el-input v-model="flashForm.eorder_pwd" maxlength="20" clearable placeholder="请输入电子面单密码">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="saveSort('flashForm')">确 认</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
  import {
    flashAdd,
    flashUpdate,
    productSaleList,
    companyList,
    companyEnable,
    companyDisable,
    companyAdd,
    companyUpdate,
    csdeliveryList,
    companyDetail
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {param} from '../../api/commonMG'
  import {timestampToTime} from '../../utils/util'

  export default {
    data: () => {
      var validateEmail = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入联系邮箱'));
        } else if (!(/[\u4E00-\u9FA5]/g,'')) {
          return callback(new Error('不能输入中文'));
        } else {
          return callback();
        }
      };
      var validateSeq = (rule, value, callback) => {
        if (value && !(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        }else {
          return callback();
        }
      };
      return {
        loading: false,
        addflashDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        voucherType: [],  // 优惠券类型
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          name: '',
          status: '',
          com_no: '',
        },
        flashForm: {
          id: "",
          name: "",
          com_no: "",
          status: "",
          contact_name: "",
          contact_tel: "",
          contact_qq: "",
          contact_email: "",
          siid: "",
          tempid: "",
          eorder_account: "",
          eorder_pwd: "",
          seq:"",
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        // rules表单验证
        rules: {
          name: [{required: true, message: '请选择公司名称', trigger: 'blur'}],
          contact_tel: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
          status: { required: true, message: '请选择状态', trigger: 'blur' },
          // contact_name: { required: true, message: '请输入联系人', trigger: 'blur' },
          // contact_qq: { required: true, message: '请输入联系QQ', trigger: 'blur' },
          // contact_email: { required: false, validator: validateEmail, trigger: 'blur' },
          // tempid: { required: true, message: '请输入打印模板', trigger: 'blur' },
          // siid: { required: true, message: '请输入打印机设备码', trigger: 'blur' },
          seq: { required: false, validator: validateSeq, trigger: 'blur' },
          // eorder_account: { required: true, message: '请输入电子面单账号', trigger: 'blur' },
          // eorder_pwd: { required: true, message: '请输入电子面单密码', trigger: 'blur' },
        },
        saleName: '',
        selectTableData: [],
        productData: [],
        productCurrentPage: 1,
        productPagesize: 10,
        productTotalSize: 0,
        small: true,
        statusList: [{
          name: '有效',
          value: 1
        }, {
          name: '无效',
          value: 0
        }],
        flashDeliveryListData: [],
        com_no: '',
        flashDeliveryName: '',
        flashName: '',
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {

    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 列表
      getdata(parameter) {
        this.loading = true
        companyList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增快递弹窗
      addflashdialog() {
        this.addflashDialogVisible = true;
        this.dialogTitle = '新增快递';
        this.flashForm = {
          id: "",
          name: "",
          com_no: "",
          status: "",
          contact_name: "",
          contact_tel: "",
          contact_qq: "",
          contact_email: "",
          siid: "",
          tempid: "",
          eorder_account: "",
          eorder_pwd: "",
          seq:"",
        };
        this.getLabel();
      },
      getLabel(flashName) {
        let param = {
          page: 1,
          rows: 10,
          name: flashName,
        }
        csdeliveryList(param)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
                if (!res.content) {
                  this.flashDeliveryName = ''
                }
                this.flashDeliveryListData = res.content;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.flashName = val;
        this.getLabel(val)
      },
      focusLabelName() {
        if (!this.flashDeliveryName) {
          this.name = ''
          this.getLabel('')
        }
      },
      changeLabelName(e) {
        console.log(e)
        this.flashDeliveryListData.forEach((item) => {
          if (item.id == e) {
            console.log(e)
            this.flashDeliveryName = item.name;
            this.getLabel(item.name);
            this.com_no = item.com_no;
          }
        })
      },
      clear() {
        this.getLabel()
        this.flashForm = ''
      },
      // 修改快递弹窗
      editflashdialog() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.addflashDialogVisible = true;
        this.dialogTitle = '修改快递';
        this.detail(this.selectTableData[0].id);
      },
      async detail(id,name) {
        const res = await this.getLabel(name)
        this.loading = true
        companyDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
               if(res.content) {
                 this.flashForm.name = res.content.name;
                 this.flashForm.com_no = res.content.com_no;
                 this.flashForm.contact_name = res.content.contact_name;
                 this.flashForm.contact_tel = res.content.contact_tel;
                 this.flashForm.contact_qq = res.content.contact_qq;
                 this.flashForm.contact_email = res.content.contact_email;
                 this.flashForm.status = res.content.status;
                 this.flashForm.seq = res.content.seq;
                 this.flashForm.eorder_account = res.content.eorder_account;
                 this.flashForm.eorder_pwd = res.content.eorder_pwd;
                 this.com_no = res.content.com_no;
                 this.flashDeliveryName = res.content.name;
               }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 删除弹窗
      // delflash() {
      //   if (this.selectTableData.length == 0) {
      //     this.$message.error('请选择一条数据再操作!');
      //     return
      //   }
      //   if (this.selectTableData.length > 1) {
      //     this.$message.error('当前操作只能选择一条数据!');
      //     return
      //   }
      //   const title = '是否确认删除快递公司？删除后将无法使用该快递公司发货？';
      //   this.$confirm(title, '删除快递', {
      //     confirmButtonText: '确定删除',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.loading = true;
      //     companyDisable(this.selectTableData[0].id)
      //       .then(res => {
      //         this.loading = false
      //         if (res.success == false) {
      //           this.$message({
      //             type: 'info',
      //             message: res.msg
      //           })
      //         } else {
      //           this.$message({
      //             type: 'success',
      //             message: '您已成功删除快递公司！'
      //           });
      //           this.getdata(this.formInline)
      //         }
      //       })
      //       .catch(err => {
      //         this.loading = false
      //         this.$message.error('网络错误，请稍后再试！')
      //       })
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消'
      //     });
      //   });
      // },
      // 确认-新增快递
      saveSort(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.flashForm.name = this.flashDeliveryName;
            this.flashForm.com_no = this.com_no;
            this.loading = true;
            if (this.dialogTitle == '新增快递') {
              companyAdd(this.flashForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增快递'
                    });
                    this.addflashDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.flashForm.id = this.selectTableData[0].id;
              this.flashForm.name = this.flashDeliveryName;
              this.flashForm.com_no = this.com_no;
              companyUpdate(this.flashForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改快递'
                    });
                    this.addflashDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false;
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline);
        // if(name, sta) {
        // }
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleClose() {
        this.$refs["flashForm"].resetFields();
        this.addflashDialogVisible = false;
      },
      // 无效有效状态
      changeStatus(id, status) {
        if (!status) {
          companyDisable(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          companyEnable(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }

</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .flashForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .flashForm .el-input {
    width: 320px;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .flashForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .flashForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .flashForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

</style>



// WEBPACK FOOTER //
// src/views/store/storeExpress.vue